define('home/views/ChannelGroupFeedsView',[
    'core/constants/exploreModuleConstants',

    'home/views/common/FetchableCollectionLayout',
    'home/views/common/TabbedView',
    'home/views/HideOnEndFooterView',
    'home/views/ForumCountCardCollectionView',
    'home/views/ChannelCardExploreView',
    'home/views/ChannelCardCollectionView',

    'home/templates/channelGroupFeeds',
], function (
    exploreModuleConstants,

    FetchableCollectionLayout,
    TabbedView,
    HideOnEndFooterView,
    ForumCountCardCollectionView,
    ChannelCardExploreView,
    ChannelCardCollectionView,

    channelGroupFeedsTemplate
) {
    'use strict';

    /**
     * Shows feed(s) for a Channel Group. By Default only shows the top source channels
     * feed, but can be set to show other feeds as tabs.
     *
     * Expects a ChannelGroupProfile model.
     */
    var ChannelGroupFeedsView = TabbedView.extend({
        defaultTab: function () {
            if (this.tabs && this.tabs.length === 1)
                return this.tabs[0].id;

            return 'top';
        },

        template: channelGroupFeedsTemplate,
        templateHelpers: function () {
            return {
                tabs: this.tabs,
                numTabs: this.tabs.length,
                exploreTab: this.exploreTab,
                channelGroupTab: this.channelGroupTab,
            };
        },

        initialize: function (options) {
            options = options || {};
            TabbedView.prototype.initialize.call(this, options);
            this.tabs = options.tabs || [exploreModuleConstants.TABS.TOP];
            this.exploreTab = options.exploreTab;
            this.channelGroupTab = options.channelGroupTab;
            this.allChannelGroupsProfile = options.allChannelGroupsProfile;
        },

        getTabView: function (activeTab) {
            switch (activeTab) {
            case 'top':
            case 'popular':
            case 'recent':
                // For the ranked channels feeds, show the feeds from the
                // special all channel groups profile.
                var model = this.channelGroupTab === 'all' ? this.allChannelGroupsProfile : this.model;

                model.ensureFetchedRankedChannels(activeTab);
                var feed = model.rankedChannels[activeTab];
                return new FetchableCollectionLayout({
                    fetchableCollectionView: ForumCountCardCollectionView,
                    fetchableCollectionFooterView: HideOnEndFooterView,
                    model: feed,
                    collection: feed.items,
                    infiniteScroll: true,
                });
            case 'discussions':
                // For the top activities feed, show the feed from the
                // spotlight channel group profile.
                this.model.ensureFetchedTopActivities();
                return new FetchableCollectionLayout({
                    className: 'explore-discussion__wrapper',
                    model: this.model.topActivities,
                    collection: this.model.topActivities.items,
                    itemView: ChannelCardExploreView,
                    channel: this.model.channel,
                    fetchableCollectionView: ChannelCardCollectionView,
                    fetchableCollectionFooterView: HideOnEndFooterView,
                    infiniteScroll: true,
                });
            }
        },
    });

    return ChannelGroupFeedsView;
});

